export const filter = {
    id : '',
    client_id: '',
    user_id: '',
    answers: [],
    created_at: '',
    updated_at: ''
};
